// workaround for 413 request entity too large
import * as constant from './constant.js';
import * as error from './errors.js';

$(() => {
    let fileInput = $('.js-file');
    if (fileInput.length) {
        fileInput.on('change', function (e) {
            let limit = fileInput.data('max-size');
            limit = limit < constant.UPLOAD_SIZE_LIMIT? limit: constant.UPLOAD_SIZE_LIMIT;
            let file = fileInput.get(0);
            for (let i = 0; i < file.files.length; i++) {
                if (file.files[i].size / 1048576 > limit) {
                    error.addErrorMessage(fileInput, `${limit}MB以下のファイルにしてください。`);
                    file.value = '';
                    return;
                }
            }
        });    
    }
});
